import { useMemo } from 'react';

import { useEnvironmentList } from '@/react/portainer/environments/queries/useEnvironmentList';
import { EnvironmentId } from '@/react/portainer/environments/types';

/**
 * Environment id to name, so the Environment column sorts and filters on the
 * name. Fetched once for the table rather than per row.
 */
export function useEnvironmentNames(): Map<EnvironmentId, string> {
  const { environments } = useEnvironmentList({ pageLimit: 0 });

  return useMemo(
    () =>
      new Map(
        environments.map((environment) => [environment.Id, environment.Name])
      ),
    [environments]
  );
}
